const communicationEn = {
    notice: require('lang/en/communication/Notice').default,
    poll: require('lang/en/communication/Poll').default,
    event: require('lang/en/communication/Event').default,
};

export default communicationEn;